// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1gOhx","productName":"Table_productName__PLMF2"};